<!-- ----------------------------------------------- -->
<template>
  <v-sheet
    id="tm-detail-cctv"
    class="com-pc-card container-column"
    style="height: 100%"
  >
    <!-- 観測設定時 -->
    <div class="tm-pc-detail-cctv-label mt-1">
      <template v-if="hasLatestUrl">
        <v-btn
        v-if="isCurrent"
        small
        color="success"
        class="tm-pc-detail-cctv-font mx-1"
        :outlined="showLatest === false"
        @click="showLatest = true"
        >{{ text.live.label }}</v-btn
        >
        <v-btn
          v-if="!isCurrent"
          small
          color="success"
          class="tm-pc-detail-cctv-font mx-1"
          :outlined="showLatest === false"
          @click="showLatest = true"
        >{{ text.history.label }}</v-btn
        >
      </template>
      <v-btn
        v-if="hasUsualUrl"
        small
        color="success"
        class="tm-pc-detail-cctv-font mx-1"
        :outlined="showLatest === true"
        @click="showLatest = false"
        >{{ text.normal.label }}</v-btn
      >
    </div>
    <div
      v-if="showLatest && hasLatestUrl"
      class="tm-pc-detail-cctv-latest elevation-4 mx-2 mt-1"
    >
      <v-img
        v-if="isCurrent"
        contain
        :src="printCurrentPicture"
        :alt="text.live.alt"
        :max-height="height"
        @error="liveImgError = true"
      >
        <template v-slot:placeholder>
          <v-sheet class="tm-pc-progress-content">
            <v-progress-circular
              v-slot:placeholder
              v-if="!liveImgError"
              indeterminate
              class="progress-img"
            ></v-progress-circular>
          </v-sheet>
        </template>
      </v-img>
      <v-img
        v-else
        contain
        :src="printHistoryPicture"
        :alt="text.history.alt"
        :max-height="height"
      >
        <template v-slot:placeholder>
          <v-sheet class="tm-pc-progress-content">
            <v-progress-circular
              v-slot:placeholder
              indeterminate
              class="progress-img"
            ></v-progress-circular>
          </v-sheet>
        </template>
      </v-img>
    </div>
    <div
      v-if="!showLatest && hasUsualUrl"
      class="tm-pc-detail-cctv-usual elevation-4 mx-2 mt-1"
    >
      <v-img
        contain
        :src="printNormallyPicture"
        :alt="text.normal.alt"
        :max-height="height"
        @error="normalImgError = true"
      >
        <template v-slot:placeholder>
          <v-sheet class="tm-pc-progress-content">
            <v-progress-circular
              v-slot:placeholder
              v-if="!normalImgError"
              indeterminate
              class="progress-img"
            ></v-progress-circular>
          </v-sheet>
        </template>
      </v-img>
    </div>
    <!-- <v-btn
      class="btn-yt-detail ml-auto mr-1"
      v-if="tmCctv.liveUrl"
      text
      rounded
      @click="openLiveUrl(tmCctv.liveUrl)"
    >
      <span class="btn-yt-text">LIVE配信はこちら</span>
      <img
        id="sns-yt-logo"
        src="/kawabou/img/sns_icons/yt_logo_rgb_light.png"
      />
    </v-btn> -->
  </v-sheet>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]河川カメラカード
 * TmDetailCctv.vue
 * @author ILUKE
 */

import tmObs from "./../../../lib/tmObs.js";
import PageLog from "./../../../lib/pageLog.js";
import Util from "./../../../lib/util.js";

export default {
  name: "tm-detail-cctv",
  data() {
    return {
      printHistoryPicture: "",
      /** 画像取得エラー */
      liveImgError: false,
      normalImgError: false,
      /** 文字列リソース */
      text: {
        // 現在(LIVE)
        live: {
          label: "現在",
          alt: "最新時画像",
        },
        // 過去
        history: {
          label: "過去",
          alt: "過去画像",
        },
        // 平常時
        normal: {
          label: "平常時",
          alt: "平常時画像",
        },
      },
      showLatest: true,
    };
  },
  props: {
    /** 親要素の幅 */
    width: {
      type: Number,
      default: 500,
    },
    /** 親要素の高さ */
    height: {
      type: Number,
      default: 250,
    },
  },
  mounted() {
    this.getPostCamera();
    /**
     * 観測日時が過去か現在かで処理分け
     */
    if (!this.isCurrent) {
      this.getAllHistoryData()
    } else if (this.isCurrent) {
      this.$store.commit("sns/setPrintCurrentPicture", this.printCurrentPicture);
    }
    this.$store.commit("sns/setPrintNormallyPicture", this.printNormallyPicture);
    this.refreshImage();
  },
  computed: {
    /**
     * 観測日時
     */
    appTime: {
      get() {
        return this.$store.state.app.appTime
      },
    },
    /**
     * 観測日時更新フラグ
     */
    isCurrent: {
      get() {
        return this.$store.state.app.isCurrent
      },
    },
    /**
     * 河川カメラ情報 取得
     */
    tmCctv: {
      get() {
        return this.$store.state.Telemeter.selectedTm.cctvInfo;
      },
    },
    hasLatestUrl: {
      get() {
        return tmObs.hasLatestUrl(this.tmCctv);
      },
    },
    hasUsualUrl: {
      get() {
        return tmObs.hasUsualUrl(this.tmCctv);
      },
    },
    /*
     * 提供URLで指定された画像を表示する
     * エラーが発生する場合は、画像URLで指定された画像を表示する
     */
    printCurrentPicture: {
      get() {
        const currentPicture = this.liveImgError ? this.tmCctv.subLatestUrl : this.tmCctv.latestUrl;
        this.$store.commit("sns/setPrintCurrentPicture", currentPicture);
        return currentPicture;
      },
    },
    printNormallyPicture: {
      get() {
        const normallyPicture = this.normalImgError ? this.tmCctv.subUsualUrl : this.tmCctv.usualUrl;
        this.$store.commit("sns/setPrintNormallyPicture", normallyPicture);
        return normallyPicture;
      },
    },
    /** 水位グラフ切替 */
    obsGraph: {
      get() {
        return this.$store.state.Telemeter.obsDispStatus.obsGraph;
      },
    },
    /** 観測地一覧切替 */
    valuesList: {
      get() {
        return this.$store.state.Telemeter.obsDispStatus.valuesList;
      },
    },
    originProduction: {
      get() {
        return this.$store.state.app.config.originProduction;
      },
    },
    historyCamUrl: {
      get() {
        return this.$store.state.app.config.tmObsConfig.historyCamUrl;
      },
    },
    testEnvironmentsIp: {
      get() {
        return this.$store.state.app.config.testEnvironmentsIp;
      },
    },
    /** アクセスログ用 */
    obsFcd: {
      get() {
        return (
          ("0000" + this.$store.state.Telemeter.selectedTmParam.ofcCd).slice(
            -5
          ) +
          ("00" + this.$store.state.Telemeter.selectedTmParam.itmkndCd).slice(
            -3
          ) +
          ("0000" + this.$store.state.Telemeter.selectedTmParam.obsCd).slice(-5)
        );
      },
    },
  },
  methods: {
    getPostCamera() {
      this.$log.debug("[TmSwCctvDetail] getPostCamera()");
      if (this.showLatest) {
        this.$store.dispatch("sns/getPostCamera", { camera: "live" });
      } else {
        this.$store.dispatch("sns/getPostCamera", { camera: "normal" });
      }
    },
    refreshImage() {
      if (this.hasLatestUrl) {
        URL.revokeObjectURL(this.printCurrentPicture);
      }
      if (this.hasUsualUrl) {
        URL.revokeObjectURL(this.printNormallyPicture);
      }
    },
    openLiveUrl(url) {
      // アクセスログ出力
      PageLog.log({
        page_log: "mob_sns",
        obs_cd: this.obsFcd,
        cam_cd: "-",
        cam_sb: "-",
        device_sb: this.$store.state.app.mode,
        sns: "yt",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });

      this.$log.debug("[TmCctv] openLiveUrl(" + url + ")");
      var win = window.open("", "_blank");
      if (url != null) {
        win.location.href = url;
      }
    },
    /** 過去観測時間の場合、過去画像を表示 */
    async getAllHistoryData() {
      const historyImageUrl = await tmObs.obsAppTimeArray(this.getSelectedObsData(), this.originProduction, this.historyCamUrl, this.testEnvironmentsIp);
      this.updatePrintCurrentPicture(historyImageUrl);
    },
    getSelectedObsData() {
      const appTime = Util.toDate(this.appTime);
      const currProvUrl = this.$store.state.Telemeter.selectedTm.cctvInfo.latestUrl;
      const cameraId = tmObs.extractImageName(currProvUrl);
      const itmkndCd = this.$store.state.Telemeter.selectedTmParam.itmkndCd;
      const sysId = this.$store.state.Telemeter.selectedTm.cctvInfo.sysId;

      return {
        appTime: appTime,
        cameraId: cameraId,
        itmkndCd: itmkndCd,
        sysId: sysId,
      }
    },
    updatePrintCurrentPicture(historyImageUrl) {
      this.printHistoryPicture = historyImageUrl;
      this.$store.commit("sns/setPrintCurrentPicture", this.printHistoryPicture);
    }
  },
  watch: {
    showLatest() {
      this.$log.debug("[rp]watch - getPostCamera()");
      this.getPostCamera();
    },
    // カメラ情報取得 監視
    tmCctv() {
      if (this.isCurrent) {
        this.$store.commit(
          "sns/setPrintCurrentPicture",
          this.printCurrentPicture
        );
      }
      this.$store.commit(
        "sns/setPrintNormallyPicture",
        this.printNormallyPicture
      );
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
